<script>
  import CrabIcon from "./icons/CrabIcon.svelte";
  import BigEyes from "./icons/BigEyes.svelte";

  export let message;

  function subscriptionInvalid() {
    return message.error === "subscription not valid";
  }
</script>

<style>
  .error {
    display: flex;
    font-family: var(--font-family-heading);
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    max-width: 500px;
    padding: 0 1rem;
  }

  .error-wrap {
    width: 600px;
    text-align: center;
  }

  .error-wrap img {
    width: 100%;
  }

  .crab {
    font-size: 4.5rem;
  }

  .wrap {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  h2 {
    font-size: 2rem;
    margin: 0.5rem 0;
  }

  p {
    margin: 0.5rem 0;
  }
</style>

<section class="error">
  {#if subscriptionInvalid()}
    <div class="wrap">
      <CrabIcon className={'empty-crab'} />
      <h2>No WaniKani Subscription Found!</h2>
      <p>
        You need to subscribe to WaniKani to view levels past level 3. Come back
        once you've paid tribute to the Crabigator!
      </p>
    </div>
  {:else}
    <BigEyes className={'error-eyes'} />
    <h2>We Messed Up</h2>
    <p>
      Yeah sorry, it looks like we encountered an error when handling that last
      request. Please refresh the page and try entering your API key again if
      prompted to do so. If this keeps happening, check your Internet
      connection.
    </p>
    <div class="error-wrap" />
  {/if}
</section>
